import script from "./MessageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDialog.vue?vue&type=script&setup=true&lang=js"

import "./MessageDialog.vue?vue&type=style&index=0&id=0e7d44ce&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e7d44ce"]])

export default __exports__